export enum Level {
  Basic = 'Basic', // Intermediate in app
  Intermediate = 'Intermediate', // Advanced in app
  Expert = 'Expert', // not used in app currently
  Beginner = 'Beginner', // Basic in app
}
